import { render, staticRenderFns } from "./PlanAlokasiMuat.vue?vue&type=template&id=64b1dba6&scoped=true&"
import script from "./PlanAlokasiMuat.vue?vue&type=script&lang=js&"
export * from "./PlanAlokasiMuat.vue?vue&type=script&lang=js&"
import style0 from "./PlanAlokasiMuat.vue?vue&type=style&index=0&id=64b1dba6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b1dba6",
  null
  
)

export default component.exports